var map = {
	"./0/Kambi/SecondaryMenu.layout.js": [
		8017,
		[
			2022,
			3879
		]
	],
	"./0/Poker/SecondaryMenu.layout.js": [
		4131,
		[
			2022,
			8625
		]
	],
	"./0/Spectate/SecondaryMenu.layout.js": [
		33790,
		[
			2022,
			6246
		]
	],
	"./1/Kambi/SecondaryMenu.layout.js": [
		21623,
		[
			1450
		]
	],
	"./1/Poker/SecondaryMenu.layout.js": [
		83330,
		[
			2022,
			7147
		]
	],
	"./1/Spectate/SecondaryMenu.layout.js": [
		97680,
		[
			2022,
			2003
		]
	],
	"./31/Kambi/SecondaryMenu.layout.js": [
		38185,
		[
			2022,
			4391
		]
	],
	"./31/Poker/SecondaryMenu.layout.js": [
		38342,
		[
			2022,
			796
		]
	],
	"./31/Spectate/SecondaryMenu.layout.js": [
		78059,
		[
			2022,
			8068
		]
	],
	"./58/Spectate/SecondaryMenu.layout.js": [
		39885,
		[
			2022,
			2719
		]
	],
	"./75/Kambi/SecondaryMenu.layout.js": [
		66881,
		[
			2022,
			6719
		]
	],
	"./75/Spectate/SecondaryMenu.layout.js": [
		97550,
		[
			2022,
			4724
		]
	],
	"./76/Kambi/SecondaryMenu.layout.js": [
		81061,
		[
			2022,
			9108
		]
	],
	"./76/Spectate/SecondaryMenu.layout.js": [
		5089,
		[
			2022,
			3327
		]
	],
	"./8/Poker/SecondaryMenu.layout.js": [
		23323,
		[
			2022,
			8838
		]
	],
	"./8/Spectate/SecondaryMenu.layout.js": [
		65881,
		[
			2022,
			2669,
			3022
		]
	],
	"./81/Kambi/SecondaryMenu.layout.js": [
		68634,
		[
			2022,
			2522
		]
	],
	"./81/Spectate/SecondaryMenu.layout.js": [
		85447,
		[
			2022,
			1845
		]
	],
	"./84/Kambi/SecondaryMenu.layout.js": [
		45614,
		[
			2022,
			4635
		]
	],
	"./84/Spectate/SecondaryMenu.layout.js": [
		16140,
		[
			2022,
			7484
		]
	],
	"./86/Spectate/SecondaryMenu.layout.js": [
		41529,
		[
			2022,
			5290
		]
	],
	"./87/Spectate/SecondaryMenu.layout.js": [
		88894,
		[
			2022,
			8919
		]
	],
	"./88/Spectate/SecondaryMenu.layout.js": [
		93507,
		[
			2022,
			1288
		]
	],
	"./89/Spectate/SecondaryMenu.layout.js": [
		84560,
		[
			2022,
			5290,
			7709
		]
	],
	"./90/Spectate/SecondaryMenu.layout.js": [
		27186,
		[
			2022,
			5290,
			5883
		]
	],
	"./91/Spectate/SecondaryMenu.layout.js": [
		71917,
		[
			2022,
			5290,
			9774
		]
	],
	"./92/Spectate/SecondaryMenu.layout.js": [
		29860,
		[
			2022,
			7253
		]
	],
	"./94/Spectate/SecondaryMenu.layout.js": [
		58521,
		[
			2022,
			8439
		]
	],
	"./95/Spectate/SecondaryMenu.layout.js": [
		71636,
		[
			2022,
			5738
		]
	],
	"./96/Poker/SecondaryMenu.layout.js": [
		91694,
		[
			2022,
			3545
		]
	],
	"./96/Spectate/SecondaryMenu.layout.js": [
		45780,
		[
			2022,
			2669,
			2593
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 21871;
module.exports = webpackAsyncContext;